import { Injectable } from '@angular/core';
import { StateManagerProjectService } from '@state-manager/state-manager-project.service';
import { Observable, of, Subscription, timer } from 'rxjs';
import { ProjectActionsRequestService } from './project-actions-request.service';

@Injectable()
export class TimeTrackerService {
  private _subscriptionTimer: Subscription;
  private _spendedTime: number = 0;

  constructor(
    private _stateManagerProjectService: StateManagerProjectService,
    private _projectActionsRequestService: ProjectActionsRequestService
  ) {}

  public init(): void {
    this._spendedTime = 0;
    console.log('case open/review time initiated: ', this._spendedTime);
    const source = timer(1000, 1000);
    this._subscriptionTimer = source.subscribe((sec: number) => {
      this._spendedTime = sec;
    });
    console.log('Review time on init end: ', this._spendedTime);
  }

  public destroy(): void {
    console.log('Review time in seconds in destroy method: ', this._spendedTime);
    if (this._spendedTime === 0) {
      return;
    }
    this._projectActionsRequestService
      .requestUpdateReviewTime(
        this._stateManagerProjectService.caseId,
        this._spendedTime
      )
      .subscribe(() => {
        console.log('Review time updated successfully ', this._spendedTime);
        this.timeRefresh();
      });
  }

  public destroyObservable(): Observable<any> {
    console.log('Review time in seconds in destroyObservable method: ', this._spendedTime);
    if (this._spendedTime === 0) {
      return of(null);
    }
    return this._projectActionsRequestService.requestUpdateReviewTime(
      this._stateManagerProjectService.caseId,
      this._spendedTime
    );
  }

  public timeRefresh(): void {
    console.log('Review time to be stopped: ', this._spendedTime);
    this._spendedTime = 0;
    this._subscriptionTimer?.unsubscribe();
    console.log('Review time stopped successfully: ', this._spendedTime);
  }
}
